import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';
// Ավելացնում ենք սոցիալական icon-ները
import { faTelegram, faWhatsapp, faViber, faFacebookMessenger, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { API_BASE } from './apiConfig';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [settings, setSettings] = useState({
    phone: '+374 (98) 71-23-71',
    email: 'info@liber.am', // Փոխեցի քո նշած մեյլին
    address: 'Երևան, Հայաստան'
  });

  useEffect(() => {
    fetch(`${API_BASE}/api/settings`, {
      headers: {
        'ngrok-skip-browser-warning': 'true',
        'Accept-Language': i18n.language
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data) {
          setSettings(prevSettings => ({
            phone: data.phone || prevSettings.phone,
            email: data.email || prevSettings.email,
            address: data.address || prevSettings.address
          }));
        }
      })
      .catch(err => console.error("Footer settings fetch error:", err));
  }, [i18n.language]);

  // Հեռախոսահամարը մաքրում ենք ավելորդ սիմվոլներից լինկերի համար
  const rawPhone = settings.phone.replace(/\D/g, '');

  return (
    <footer className="main-footer">
      <div className="footer-container">
        
        {/* 1. Լոգո */}
        <div className="footer-section">
          <h2 className="footer-logo">LIBER GROUP</h2>
          <p style={{fontSize: '14px', opacity: 0.8, marginTop: '10px'}}>
            © {new Date().getFullYear()} {t('footer_rights')}
          </p>
        </div>

        {/* 2. Ընկերություն */}
        <div className="footer-section">
          <h3>{t('footer_company')}</h3>
          <ul>
            <li><Link to="/about">{t('footer_about')}</Link></li>
            <li><Link to="/portfolio">{t('footer_projects')}</Link></li>
            <li><Link to="/terms">{t('footer_terms')}</Link></li>
          </ul>
        </div>

        {/* 3. Կապ և Սոցիալական ցանցեր */}
        <div className="footer-section">
          <h3>{t('footer_contact')}</h3>
          <div className="contact-item" style={{marginBottom: '10px', display: 'flex', alignItems: 'center'}}>
            <FontAwesomeIcon icon={faPhone} style={{width: '20px'}} />
            <a href={`tel:${settings.phone}`} style={{color: 'inherit', marginLeft: '10px', textDecoration: 'none'}}>
              {settings.phone}
            </a>
          </div>
          
          {/* Սոցիալական կոճակների բլոկ */}
          <div className="footer-social-grid">
            <a href={`https://wa.me/${rawPhone}`} target="_blank" rel="noopener noreferrer" className="social-btn whatsapp" title="WhatsApp">
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
            <a href={`viber://chat?number=%2B${rawPhone}`} target="_blank" rel="noopener noreferrer" className="social-btn viber" title="Viber">
              <FontAwesomeIcon icon={faViber} />
            </a>
            <a href="https://t.me/libergroup" target="_blank" rel="noopener noreferrer" className="social-btn telegram" title="Telegram">
              <FontAwesomeIcon icon={faTelegram} />
            </a>
            <a href="https://m.me/banvorner.bernapoxadrumner" target="_blank" rel="noopener noreferrer" className="social-btn messenger" title="Messenger">
              <FontAwesomeIcon icon={faFacebookMessenger} />
            </a>
            
          </div>

          <div className="contact-item" style={{marginTop: '15px', display: 'flex', alignItems: 'center'}}>
            <FontAwesomeIcon icon={faEnvelope} style={{width: '20px'}} />
            <a href={`mailto:${settings.email}`} style={{color: 'inherit', marginLeft: '10px', textDecoration: 'none', fontSize: '14px'}}>
              {settings.email}
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;